// takes in a hex color and opacity
// returns a transparent rgba
export const hexToRGBA = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// takes in a hex color and opacity
// returns an opaque rgba equivalent to the transparent hex color on white background
export const transparencyToOpaque = (hex, opacity = 1) => {
  const rgbArray = hexToRGBA(hex).match(/\d+/g);

  const adjustedRgbArray = rgbArray.map((n) => Math.round(255 - (255 - n) * opacity));

  return `rgba(${adjustedRgbArray[0]}, ${adjustedRgbArray[1]}, ${adjustedRgbArray[2]}, 1)`;
};
